import {algoliasearch} from 'algoliasearch';
import {CLAVEAPP, CLAVEBUSQUEDA} from "../Constantes";

export const buscarPalabra = async ({nombreIndex, palabra}) => {


//
    const client = algoliasearch(CLAVEAPP, CLAVEBUSQUEDA);

    const response = await client.searchSingleIndex({
        indexName: nombreIndex,
        searchParams: {query: palabra},
    });

    let hits = response.hits

    console.log(response)
    let arr = hits.map((it) => {
        delete it._highlightResult
        return it
    })

    return arr

}